/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `'Instrument Serif', serif`,
  subHeading: `'Champignon'`,
  body: `'Instrument Serif', serif`,
  name: `'Instrument Serif', serif`,
  accent: `'Instrument Serif', serif`,
};

export const FONTS = {
  display: FONT_FAMILY.heading,
  script: FONT_FAMILY.subHeading,
  body: FONT_FAMILY.body,
  accent: FONT_FAMILY.accent,
};

export const TYPE_SCALE = {
  titleHero: { base: '48px', sm: '52px' },
  titleSection: { base: '30px', sm: '34px' },
  nameLarge: { base: '42px', sm: '48px' },
  figure: { base: '38px', sm: '44px' },
  headingBlock: { base: '24px', sm: '27px' },
  body: { base: '16px', sm: '16px' },
  small: { base: '14px', sm: '15px' },
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    lineHeight: 1.15,
    textAlign: 'center',
    color: 'mainColorText',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    textAlign: 'center',
    color: 'mainColorText',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
  },
  name: {
    fontFamily: 'name',
    fontSize: 'name',
    fontWeight: 'name',
    fontStyle: 'var(--fontItalic-name)',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'tertiaryColorText',
  },
  accent: {
    fontFamily: 'accent',
    fontSize: 'body',
    fontStyle: 'italic',
    fontWeight: 'body',
    color: 'mainColorText',
    lineHeight: 1.5,
  },
};

export const TITLE_PROPS = {
  fontFamily: 'heading',
  fontWeight: 400,
  color: 'mainColorText',
  lineHeight: 0.85,
  textAlign: 'center',
};

export const ACCENT_PROPS = {
  fontFamily: 'accent',
  fontStyle: 'italic',
  fontWeight: 400,
  color: 'mainColorText',
  lineHeight: 1.5,
};

export const BODY_PROPS = {
  fontFamily: 'body',
  fontWeight: 400,
  color: 'mainColorText',
  lineHeight: 1.45,
};

export const FIELD_PROPS = {
  ...BODY_PROPS,
  bg: 'transparent',
  border: 'none',
  borderBottom: '1px solid',
  borderColor: 'rgba(244, 241, 234, 0.22)',
  borderRadius: 0,
  px: 0,
  color: 'mainColorText',
  fontSize: 'body',
  fontFamily: 'body',
  _placeholder: { color: 'alternativeColorText' },
  _hover: { borderColor: 'mainColorText' },
  _focus: { borderColor: 'mainColorText', boxShadow: 'none' },
  _focusVisible: { borderColor: 'mainColorText', boxShadow: 'none' },
};

export const FIELD_LABEL_PROPS = {
  ...BODY_PROPS,
  fontFamily: 'body',
};

export const SECTION_PX = { base: '24px', sm: '28px' };

export const SWASH = {
  scale: 1.3,
  hang: '-0.09em',
};

export const GRADE = {
  overlay: 'linear-gradient(180deg, rgba(20,26,20,0.64) 0%, rgba(20,26,20,0.48) 50%, rgba(20,26,20,0.84) 100%)',
  topDark: 'linear-gradient(180deg, rgba(12,16,12,0.92) 0%, rgba(12,16,12,0) 100%)',
  bottomDark: 'linear-gradient(180deg, rgba(12,16,12,0) 0%, rgba(12,16,12,0.96) 100%)',
  photoOverlay: 'linear-gradient(180deg, rgba(20,26,20,0.30) 0%, rgba(20,26,20,0.60) 100%)',
};

export const DEFAULT_PROPS = {
  button_transparent: {
    _active: { borderColor: 'transparent' },
    _hover: { borderColor: 'transparent' },
    _focus: { borderColor: 'transparent', boxShadow: 'none' },
    borderRadius: '16px',
    borderWidth: '1px',
    borderColor: 'transparent',
    bgColor: 'transparent',
    textDecoration: 'none',

    fontFamily: FONT_FAMILY.body,
    fontWeight: '400',
    fontSize: TYPE_SCALE.body,
    letterSpacing: 'normal',
    textTransform: 'none',
    minWidth: '100px',
  },
};
